import { createFileRoute } from '@tanstack/react-router';
import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { MemorySettings } from '@/containers/settings/memory/memory-settings.component';
import {
  memoryTabOf,
  type MemoryTab,
} from '@/containers/settings/memory/memory-tab.util';
import { SettingsLayout } from '@/containers/settings/settings-layout.component';

export const Route = createFileRoute('/settings/memory')({
  // `?tab=review` opens the Review tab (the agent page's chip links to it).
  // Any other value reads as no tab: the key stays in the result, because the
  // router merges the raw search under it and a missing key would let the
  // raw value through.
  validateSearch: (search: Record<string, unknown>): { tab?: MemoryTab } => ({
    tab: memoryTabOf(search.tab),
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { tab } = Route.useSearch();
  return (
    <>
      <Head heading='Memory' />
      <AuthCheck>
        <SettingsLayout>
          <MemorySettings tab={tab} />
        </SettingsLayout>
      </AuthCheck>
    </>
  );
}
